import clsx from 'clsx';
import React, { useState } from 'react';
import styles from './ButtonBase.module.scss';
import { Spinner } from '../Spinner/index.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export const BUTTON_SIZES = [
    'sm',
    'md',
    'lg',
    'xl'
];
export const ButtonBase = ({ size, onClick, backgroundColor, textColor, children, disabled = false, fullWidth = false, isLoading = false, 'data-testid': dataTestId })=>{
    const [isAwaitingClick, setIsAwaitingClick] = useState(false);
    const showLoading = isLoading || isAwaitingClick;
    const isActive = !disabled && !showLoading;
    const awaitAsyncClick = async (clickResult)=>{
        setIsAwaitingClick(true);
        try {
            await clickResult;
        } finally{
            setIsAwaitingClick(false);
        }
    };
    const handleClick = (event)=>{
        event.stopPropagation();
        AudioManager.play(AudioType.Click);
        const result = onClick();
        if (!(result instanceof Promise)) return;
        void awaitAsyncClick(result);
    };
    return /*#__PURE__*/ React.createElement("button", {
        className: clsx(styles.button, {
            [styles.sm]: size == 'sm',
            [styles.md]: size == 'md',
            [styles.lg]: size == 'lg',
            [styles.xl]: size == 'xl',
            [styles.disabled]: !isActive,
            [styles.fullWidth]: fullWidth
        }),
        style: {
            backgroundColor: backgroundColor,
            color: textColor
        },
        "data-testid": dataTestId,
        disabled: disabled,
        onClick: isActive ? handleClick : undefined
    }, showLoading && /*#__PURE__*/ React.createElement(Spinner, {
        className: styles.loader
    }), !showLoading && /*#__PURE__*/ React.createElement("span", {
        className: styles.label
    }, children));
};
